import { render, staticRenderFns } from "./TipModal.vue?vue&type=template&id=a652ee8a&scoped=true"
import script from "./TipModal.vue?vue&type=script&lang=js"
export * from "./TipModal.vue?vue&type=script&lang=js"
import style0 from "./TipModal.vue?vue&type=style&index=0&id=a652ee8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a652ee8a",
  null
  
)

export default component.exports